/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdStudentDataQueryResponse,
  GetApiV1PersonIdStudentDataPathParams,
  GetApiV1PersonIdStudentData401,
  GetApiV1PersonIdStudentData404,
  GetApiV1PersonIdStudentData500,
} from "../../types/personStudentController/GetApiV1PersonIdStudentData.ts";

function getGetApiV1PersonIdStudentDataUrl(
  id: GetApiV1PersonIdStudentDataPathParams["id"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/person/${id}/student-data` as const,
  };
  return res;
}

/**
 * @description Retorna os dados da aba Student da pessoa (RA, USP, currículo, perfil público e campos de graduação finalizada). **(Requer Authorization para autenticação)**
 * @summary Obter dados de aluno (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/student-data}
 */
export async function getApiV1PersonIdStudentData(
  id: GetApiV1PersonIdStudentDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdStudentDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdStudentData401
      | GetApiV1PersonIdStudentData404
      | GetApiV1PersonIdStudentData500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdStudentDataUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
